"use client";

import { useSyncExternalStore } from "react";

const LUGN = "(prefers-reduced-motion: reduce)";
/** Not on phones (Erik 2026-10-21); the site's max-sm breakpoint. */
const MOBIL = "(max-width: 639.98px)";

function prenumerera(fn: () => void): () => void {
  const listor = [LUGN, MOBIL].map((q) => window.matchMedia?.(q));
  listor.forEach((mq) => mq?.addEventListener("change", fn));
  return () => listor.forEach((mq) => mq?.removeEventListener("change", fn));
}

function tillaten(): boolean {
  return !window.matchMedia?.(LUGN).matches && !window.matchMedia?.(MOBIL).matches;
}

/** False on phones and with the OS setting "reduce motion"; false during SSR. */
export function useRorelseTillaten(): boolean {
  return useSyncExternalStore(prenumerera, tillaten, () => false);
}
